export enum AuthenticationTypes {
    ZedX = 1,
    Azure = 2
}